import { inject } from 'vue'

export const RPILOT_CONFIG = Symbol('rpilot.config')

const DEFAULTS = {
  apiBaseUrl: '/api',
  scopedToken: null,
  apiUrl: null,
  projectCode: null,
  userId: null,
  locale: null,
  initialSessionId: null,
  sessionContext: null,
  sessionCreateOptions: { agentCode: 'rpilot-ai-spa' },
  namespace: 'rpilot',
  credentials: 'include',
  headers: null,
  rdriveWebViewUrl: '/rdrive-web-view/index.html#/plan-viewer',
  bridge: null,
}

export function useRPilotConfig() {
  return inject(RPILOT_CONFIG, DEFAULTS)
}

export function resolveHeaders(cfg) {
  const h = cfg?.headers
  if (typeof h === 'function') return h() || {}
  return h || {}
}
